import { assert_equal, assert_false, assert_true, wrong_case } from '@shared/asserts/utils_asserts';
import { ENUM__string_id_empty } from '@shared/constants/ENUM__string_id_empty';
import { UTILS__crypto } from '@shared/utils/crypto/UTILS__crypto';
import { ENUM__field_kind } from '../../_enums/ENUM__field_kind';
import { FIELD__base } from '../../_fields/_base/FIELD__base';
import { DTO_GRAPH__instance } from '../../_graph/DTO_GRAPH__instance';
import { INVOCATION__base } from './INVOCATION__base';

declare module './INVOCATION__base' {
  interface INVOCATION__base {
    hash_create(): string;

    hash__update_with_graph(graph: DTO_GRAPH__instance): void;

    hash__clear(graph: DTO_GRAPH__instance): void;

    hash_hard__set_to_empty(graph: DTO_GRAPH__instance): void;

    hash__create_for_field_output(field: FIELD__base, graph: DTO_GRAPH__instance): string;
  }
}

export function INIT_EXTENSION_INVOCATION__base__hash_hard() {
  // do nothing
}

/*
 * HASH
 */

INVOCATION__base.prototype.hash_create = function () {
  wrong_case();

  return '';
};

INVOCATION__base.prototype.hash__update_with_graph = function (graph: DTO_GRAPH__instance): void {
  assert_true(this.meta.is_validated);
  assert_true(this.meta.errors.is_empty());

  const hash_values: string[] = [];

  hash_values.push(`type:${this.type}`);

  let fields_map = this.get_fields_map(true);

  let field_values = [];

  for (const [_, field] of fields_map.entries()) {
    let use_empty_hash = false;
    use_empty_hash = use_empty_hash || field.is_stub();
    use_empty_hash = use_empty_hash || (field.meta.data__is_linked && !field.meta.data__synced_by_parent_id.is_empty_uuid());

    if (use_empty_hash) {
      field.hash__set_to_empty(graph);
      continue;
    }

    field.hash__update_with_graph(graph);

    if (field.meta.field_hash__value_full.is_empty_hash_sha256()) continue;

    field_values.push(`${field.meta.field_name}:${field.meta.field_hash__value_full}`);
  }

  if (field_values.is_empty()) {
    this.meta.node_hash = ENUM__string_id_empty.HASH_SHA256;
  } else {
    hash_values.sort();

    this.meta.node_hash = UTILS__crypto.sha256.from_string(hash_values.join('|'));
  }
};

INVOCATION__base.prototype.hash__clear = function (graph: DTO_GRAPH__instance) {
  let fields_map = this.get_fields_map(true);

  for (const field of fields_map.values()) field.hash__clear(graph);

  this.meta.node_hash = ENUM__string_id_empty.HASH_SHA256;
};

INVOCATION__base.prototype.hash_hard__set_to_empty = function (graph: DTO_GRAPH__instance) {
  let fields_map = this.get_fields_map(true);

  for (const field of fields_map.values()) field.hash__set_to_empty(graph);

  this.meta.node_hash = ENUM__string_id_empty.HASH_SHA256;
};

INVOCATION__base.prototype.hash__create_for_field_output = function (field: FIELD__base, graph: DTO_GRAPH__instance) {
  if (!this.has_effect_on_generation_runtime(graph)) return ENUM__string_id_empty.HASH_SHA256;

  assert_equal(field.meta.field_kind, ENUM__field_kind.OUTPUT);

  let fields__node = this.get_fields_map(false).values();
  let values: string[] = field.hash_base_values;
  assert_false(values.is_empty());

  fields__node = fields__node.filter(field => field.meta.field_kind == ENUM__field_kind.INPUT); //keep inputs only
  fields__node = fields__node.filter(field => !field.is_stub()); //skip stubs

  for (const field__node of fields__node) {
    field__node.hash__update_with_graph(graph);

    if (field__node.meta.field_hash__value_full.is_empty_hash_sha256()) continue; //skip not hashed fields
    if (!field__node.meta.generation__has_effect_static) continue; //do not count it on hash

    values.push(`${field__node.meta.field_path}:${field__node.meta.field_hash__value_full}`);
  }

  values.sort();

  return UTILS__crypto.sha256.from_string(values.join('|'));
};
